import Region from "./Region";

function getPrettySeq(seq = "") {
  if (seq.indexOf("-") > -1) {
    const parts = seq.split("-");
    return `${parts[0]}…${parts[2]} (${getSeqLen(seq)})`;
  }
  if (seq.length > 10) {
    return `${seq.slice(0, 2)}…${seq.slice(-2)} (${seq.length})`;
  }
  return seq;
}

function getSeqLen(seq = "") {
  if (seq.indexOf("-") > -1) {
    const parts = seq.split("-");
    return parts[0].length + Number(parts[1]) + parts[2].length;
  }

  return seq.length;
}

class Variant {
  constructor(variant, chromosome) {
    this.id = variant.variant_id;
    this.ref = variant.ref || "";
    this.alt = variant.alt || "";
    this.refLength = getSeqLen(this.ref);
    this.altLength = getSeqLen(this.alt);

    this.region = new Region(
      variant.position,
      variant.position + this.refLength,
      chromosome
    );
  }

  get spec() {
    const chr = this.region.chromosome.shortName;
    const pos = this.region.x0;
    const ref = this.ref.indexOf("-") === -1;
    const alt = this.alt.indexOf("-") === -1;
    return ref && alt ? `chr${chr}-${pos}-${this.ref}-${this.alt}` : null;
  }

  get prettySpec() {
    const chr = this.region.chromosome.shortName;
    const pos = this.region.x0;
    const prettyRef = getPrettySeq(this.ref);
    const prettyAlt = getPrettySeq(this.alt);
    if (this.refLength === 0) {
      const lastDigit = Number(String(pos).slice(-1));
      const posStr = `chr${chr}:${pos - 1}_${lastDigit}`;
      return `${posStr} ins${prettyAlt}`;
    }
    if (this.altLength === 0) {
      return `chr${chr}:${pos} del${prettyRef}`;
    }
    return `chr${chr}:${pos} ${prettyRef}⇒${prettyAlt}`;
  }
}

export default Variant;
